import React from 'react';
import './mRecordGuide.scss';
import { Button, Checkbox, Iconfont, Modal } from '@umu/umu-design';
import { lang } from '@umu/ukit-lang';
import SmileImg from './image/smile.png';
import Hint1Img from './image/hint1.png';
import Hint2Img from './image/hint2.png';
import { getMiniAppSdk, isFromCourseMiniApp } from 'businessCommon/src/@utils';
import { getModuleData } from 'common/src/services';
import { openWindow } from '@umu/umu-dom';
import { localStorageHelper } from '@umu/umu-storage';
interface IProps {
    onClose: () => void;
    sessionId?: string;
}
const STORAGE_KEY = 'isShowMRecordGuide';
export const MRecordGuide = (props: IProps) => {
    const toRecord = () => {
        if (isFromCourseMiniApp()) {
            getMiniAppSdk().navigateTo(`/subModuleA/pages/aiVideoExerciseCover/index?sessionId=${props.sessionId}`);
        } else {
            const siteHost = getModuleData('siteHost');
            const url = `//m.${siteHost}/exercise/record/${props.sessionId}`;
            openWindow(url, '_self');
        }
        props.onClose();
    };
    const onShowModal = () => {
        const isShow = localStorageHelper.get(STORAGE_KEY);
        if (isShow === '1') {
            toRecord();
            return;
        }
        Modal.confirm({
            title: lang('重要提示'),
            className: 'screen-guide-modal',
            width: 320,
            okButtonProps: {
                type: 'text',
                style: {
                    color: '#1e6ee6',
                    fontWeight: 400,
                },
            },
            content: (
                <div className="screen-guide-content">
                    <div>
                        {lang('1.录制过程中手机画面旋转会导致录制中断，建议您锁定手机方向后，再横置手机开始拍摄。')}
                    </div>
                    <div>{lang('2.建议使用Chrome浏览器，其他浏览器可能会录制失败。')}</div>
                    <div className="check_box">
                        <Checkbox
                            onChange={(e) => {
                                if (e.target.checked) {
                                    localStorageHelper.set(STORAGE_KEY, '1');
                                } else {
                                    localStorageHelper.del(STORAGE_KEY);
                                }
                            }}
                        >
                            {lang('下次不再提醒')}
                        </Checkbox>
                    </div>
                </div>
            ),
            onOk: () => {
                toRecord();
            },
            okText: lang('确定'),
            closable: false,
            centered: true,
        });
    };

    return (
        <div
            className="mRecordGuide"
            onTouchMove={(e) => {
                e.stopPropagation();
            }}
        >
            <Iconfont type="Close" className="close_icon" onClick={props.onClose} />
            <div className="block block-1">
                <img src={SmileImg} alt="" className="main-img" />
                <div className="main-tip">
                    {lang('横置手机，保持微笑，使用适中的语速，流畅地进行讲述。使用手势会让你的表达更加顺畅和自然。')}
                </div>
            </div>
            <div className="block block-2">
                <div className="tip-title">{lang('提示')}</div>
                <div className="tips1">
                    <img src={Hint1Img} alt="" className="img1" />
                    <div className="title1">{lang('光线充足 正对手机')}</div>
                </div>
                <div className="tips1">
                    <img src={Hint2Img} alt="" className="img2" />
                    <div className="title1">{lang('避免背景杂乱，尽量选择单一的背景拍摄')}</div>
                </div>
            </div>

            <Button className="btn" onClick={onShowModal}>
                {lang('横置手机，开始 AI 拍摄')}
            </Button>
            <div className="tip">{lang('建议使用 Chrome 浏览器')}</div>
        </div>
    );
};
